import { SelectLayout } from "./interfaces";
export var defaultProps = {
  layout: SelectLayout.Default,
  options: [],
  valueAccessor: 'value',
  getTriggerText: function getTriggerText(numberOfSelectedItems) {
    return "".concat(numberOfSelectedItems, " item").concat(numberOfSelectedItems > 1 ? 's' : '', " selected");
  },
  placeholder: 'Choose an option',
  customSelectionOptionsLabel: 'Group selection options',
  defaultOptionsLabel: 'Single selection options',
  disabledTagsHiddenText: 'The options in this list are not dismissible because the input is disabled',
  selectedOptionAltText: 'selected',
  width: '100%',
  collapsedOptionsExpanderTitle: 'Selected items',
  searchFieldAriaLabel: 'Start typing to filter out search results',
  noOptionsText: 'No options available'
};
export var defaultFilterOptions = function defaultFilterOptions(options, optionToString) {
  return function (query) {
    return options.filter(function (option) {
      return optionToString(option).toLowerCase().includes(query.toLowerCase());
    });
  };
};
export var TEXT_COLOR = 'neutral90';
export var PLACEHOLDER_TEXT_COLOR = 'neutral70';